import React, { useState, useEffect } from "react";
import Accordion from './Accordion';
import './accordion.css';

function Answers() {
  const [isShowIndex, setIsShowIndex] = useState(0);
  const [answers, setAnswers] = useState([
    {
      title: 'Choose the Region',
      subTitle: 'Selecting your region helps us provide the most accurate product options, services, and pricing available in your area.',
    },
    {
      title: 'Choose the Monitors',
      subTitle: 'Selecting your region helps us provide the most accurate product options,',
    },
    {
      title: 'Choose the number of spots',
      subTitle: 'Selecting your region helps us provide the most accurate product options,',
    },
    {
      title: 'Upload the video',
      subTitle: 'Selecting your region helps us provide the most accurate product options,',
    },
    {
      title: 'Get Approval From the operator',
      subTitle: 'Selecting your region helps us provide the most accurate product options,',
    },
  ]);

  // Fetch data from Strapi
  useEffect(() => {
    const fetchAnswersData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_STRAPI_API_URL}/api/howtouses`);
        const result = await response.json();
        if (result.data && result.data.length > 0) {
          const data = result.data[0];
          const newAnswers = [];

          // Dynamically extract titleX and descriptionX pairs
          let index = 1;
          while (data[`title${index}`] && data[`description${index}`]) {
            newAnswers.push({
              title: data[`title${index}`],
              subTitle: data[`description${index}`],
            });
            index++;
          }

          // Update answers if valid data is found
          if (newAnswers.length > 0) {
            setAnswers(newAnswers);
          }
        }
      } catch (error) {
        console.error('Error fetching Strapi data:', error);
      }
    };

    fetchAnswersData();
  }, []);

  return (
      <div className="container accordContent">
        <div className="accordion">
          <h3>How to Use?</h3>
        </div>
        {answers.map((item, index) => {
          return (
              <Accordion
                  key={index}
                  title={item.title}
                  subTitle={item.subTitle}
                  onClick={() => {
                    setIsShowIndex(index === isShowIndex ? null : index);
                  }}
                  isShow={index === isShowIndex}
              />
          );
        })}
      </div>
  );
}

export default Answers;